export default __webpack_public_path__ + "static/media/Checked_Icon.a27c8f82.svg";